import store from '@/state/store'

export default [
  {
    path: '',
    name: 'home',
    meta: {
      authRequired: true,
    },
    component: () => import('../pages')
  },
  {
    path: '/chat/:id',
    name: 'chat',
    meta: {
      authRequired: true,
    },
    component: () => import('../pages'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/auth/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({name: 'home'})
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        next({name: 'login'})
      },
    },
  },
]
